export function isPrefetchRequest(event) {
  const headers = event.detail?.fetchOptions?.headers
  if (!headers) return false

  const purpose = typeof headers.get === "function"
    ? headers.get("X-Sec-Purpose")
    : headers["X-Sec-Purpose"] || headers["x-sec-purpose"]
  return purpose === "prefetch"
}

// Frame navigation requests target the <turbo-frame>; a form submission targets the form.
// Turbo's hover prefetch targets the hovered link and carries X-Sec-Purpose: prefetch.
export function isInteractiveFrameRequest(event, frame) {
  if (isPrefetchRequest(event)) return false

  return event.target === frame || event.target?.matches?.("form") === true
}
